import React from 'react';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Box from '@material-ui/core/Box';
import classNames from 'classnames';

import { makeFooterStyles } from 'styles/layout/footer';
import FooterStyled from './Footer.styled';
import footerLinks from './links';
import '@gwo/ecommerce-common-components/dist/ecommerce-common-components.css';
import './footer.css';

import CookieInfoDialog from 'common/components/CookieInfoDialog';
import CookiePanel from './CookiePanel';

const headerLinkClasses = [
    'gwo-footer__link-header',
    'gwo-footer__link-header--uppercase',
];

const Footer = () => {
    const {
        expansionPanelSummary,
        plusIcon
    } = makeFooterStyles();

    return (
        <FooterStyled data-gwo-footer className="gwo-footer footer-margin">
            <div className="gwo-footer__container">
                <section className="gwo-footer__navigation-wrapper">
                    {footerLinks.map((link: any, index: any) =>
                        <nav className="nav-item" key={index}>
                            <Box display={{ xs: 'block', md: 'none' }}>
                                <ExpansionPanel classes={{ root: 'footer-expansion-panel' }}>
                                    <ExpansionPanelSummary
                                        classes={{
                                            root: 'footer-expansion-panel-summary-root',
                                            content: 'footer-expansion-panel-summary-content'
                                        }}
                                        className={expansionPanelSummary}
                                    >
                                        <h2 className={classNames(headerLinkClasses, { active: link.active })}>
                                            {link.label}
                                        </h2>
                                        <div className={plusIcon}>
                                            <div className="line-horizontal" />
                                            <div className="line-vertical" />
                                        </div>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails classes={{ root: 'footer-expansion-panel-details' }}>
                                        <ul className={classNames('gwo-footer__links-container ', { active: link.active, })}>
                                            {link.links.map((sublink: any, index: any) =>
                                                <li className="gwo-footer__item" key={index}>
                                                    <a className="gwo-footer__link"
                                                        href={sublink.url}>{sublink.label}</a>
                                                </li>)}
                                        </ul>
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                            </Box>
                            <Box display={{ xs: 'none', md: 'block' }}>
                                <h2 className={classNames(headerLinkClasses, { active: link.active, })}>
                                    {link.label}
                                </h2>
                                <ul className={classNames('gwo-footer__links-container', { active: link.active, })}>
                                    {link.links.map((sublink: any, index: any) =>
                                        <li className="gwo-footer__item" key={index}>
                                            <a className="gwo-footer__link"
                                               href={sublink.url}>{sublink.label}</a>
                                        </li>)}
                                </ul>
                            </Box>
                        </nav>
                    )}
                </section>

                <div className="gwo-footer__divider" />
                <section className="gwo-footer__copyright-container">
                    <ul className="gwo-footer__copyright-links">
                        <span className="gwo-footer__copyright-text">
                            <li className="gwo-footer__item">
                                <span className="gwo-footer__copyright-text">Copyright © by Gdańskie Wydawnictwo Oświatowe - {new Date().getFullYear()}</span>
                            </li>
                            <li className="gwo-footer__item">
                                <span className="gwo-footer__copyright-text">
                                    <div>Ta strona używa plików cookies.&nbsp;&nbsp;
                                        <CookieInfoDialog>
                                        {({ handleClickOpen, }) => (
                                            <a className="gwo-footer__link" onClick={handleClickOpen} style={{ cursor: 'pointer', }}>Dowiedz się więcej</a>
                                        )}
                                </CookieInfoDialog>
                                    </div>
                                </span>
                            </li>
                            <li className="gwo-footer__item">
                                <a className="gwo-footer__link" href="https://gwo.pl/rodo/">Rodo</a>
                            </li>
                        </span>
                    </ul>
                </section>
            </div>
            <CookiePanel/>
        </FooterStyled>
    );
};

export default Footer;
